// extracted by mini-css-extract-plugin
module.exports = {"container":"footer_link_container_container__2edjP"};